<template>
	<div
		class="flex w-screen shrink-0 flex-col overflow-auto pt-15 pb-lg lg:w-[450px]"
	>
		<slot></slot>
	</div>
</template>
